<template>
  <div :class="{ 'blur-md pointer-events-none': blocked }">
    <RouterView v-if="initialised" />
  </div>
</template>

<script>
import { authStore } from "@/stores/auth";
import { mapActions, mapGetters, mapState } from "pinia";
import api from "@/api.js";

export default {
  name: "PageShell",
  data() {
    return {
      blocked: false,
      initialised: false,
    };
  },
  async mounted() {
    this.handleMetaInappBrowser();
    try {
      await this.refreshSignupInfo();
      this.refreshCountryCode();
    } catch (e) {
      console.error(e);
      if (this.handleUrlRedirect()) {
        console.log("redirecting");
        return;
      } else {
        this.$router.replace({ name: "notFound" });
        return;
      }
    }
    if (this.organizationConfig?.missingPaymentBlock) {
      this.$notificationGenerator.create({
        title: this.$t("deactivated-page-title"),
        type: "error",
        closable: false,
        content: this.$t("deactivated-page-message"),
        duration: 1200000,
      });
      this.blocked = true;
    }
    if (
      this.$router.currentRoute.value.name === "ratingPage" ||
      this.$route.meta.shop
    ) {
      this.initialised = true;
      return;
    }
    if (this.$route.query?.replaceCustomerId) {
      let customer = (
        await api.get(`/customer/${this.$route.query.replaceCustomerId}`)
      ).data;
      this.updateCurrentCustomer(customer);
    }
    if (this.currentCustomer?.organizationId === this.organization.id) {
      if (this.handleUrlRedirect()) return;
      if (this.$route.query?.addPoints) {
        this.$router.replace({
          name: "addPointsPage",
          query: { ...this.$route.query, addPoints: undefined },
        });
        return;
      }
      // Skip game redirect for profile page
      if (this.$router.currentRoute.value.name !== "customerProfilePage") {
        let unplayedGameParticipation = (
          await api.get(
            `/customer/${this.currentCustomer.id}/unplayedGameParticipation`
          )
        ).data.gameParticipation;
        if (unplayedGameParticipation) {
          await this.$router.replace({
            name: "gamePage",
            query: { ...this.$route.query },
            params: {
              gameParticipationId: unplayedGameParticipation.id,
            },
          });
        }
      }
    }
    this.initialised = true;
  },
  methods: {
    ...mapActions(authStore, [
      "refreshSignupInfo",
      "refreshCountryCode",
      "updateCurrentCustomer",
    ]),
    handleMetaInappBrowser() {
      if (
        (window.navigator.userAgent.includes("Instagram") ||
          window.navigator.userAgent.includes("FB")) &&
        this.deviceIsIphone
      ) {
        window.location.href = window.location.href.replace(
          "https:",
          "x-safari-https:"
        );
      }
    },
    handleUrlRedirect() {
      if (this.$route.query?.lastappUrl) {
        console.log("Redirecting to lastappUrl");
        let paramsComponent = "";
        if (
          this.currentCustomer?.phoneNumber &&
          this.currentCustomer?.organizationId === this.organization?.id
        ) {
          paramsComponent = `&customerPhone=${this.currentCustomer.phoneNumber}`;
        }
        window.location.replace(this.$route.query.lastappUrl + paramsComponent);
        return true;
      }
    },
  },
  computed: {
    ...mapGetters(authStore, ["locationsBySlug"]),
    ...mapState(authStore, [
      "locations",
      "currentCustomer",
      "organization",
      "organizationConfig",
      "branding",
      "deviceIsIphone",
    ]),
  },
  components: {},
};
</script>

<style scoped>
.floatting {
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
